import { useDebounce } from '@pancakeswap/hooks'
import { useTranslation } from '@pancakeswap/localization'
import { useActiveChainId } from '@/hooks/useActiveChainId'
import { useGetENSAddressByName } from '@/hooks/useGetENSAddressByName'
import { useCallback } from 'react'
import { safeGetAddress, getBlockExploreLink, getBlockExploreName } from '@/utils'
import Link from 'next/link'
import clsx from 'clsx'

export default function AddressInputPanel({
  id,
  value,
  onChange,
}: {
  id?: string
  // the typed string value
  value: string
  // triggers whenever the typed value changes
  onChange: (value: string) => void
}) {
  const { chainId } = useActiveChainId()

  const { t } = useTranslation()
  const debounceEnsName = useDebounce(value, 500)
  const recipientENSAddress = useGetENSAddressByName(debounceEnsName)

  const address = safeGetAddress(value) ? value : safeGetAddress(recipientENSAddress)

  const handleInput = useCallback(
    (event) => {
      const input = event.target.value
      const withoutSpaces = input.replace(/\s+/g, '')
      onChange(withoutSpaces)
    },
    [onChange],
  )

  const error = Boolean(value.length > 0 && !address)

  return (
    <div
      className={clsx('bg-card rounded-2xl border p-4 mt-2', {
        '!border-red-400': error,
      })}
    >
      <div>
        <div>
          <div className={'text-card-foreground'}>{t('Recipient')}</div>
          {address && chainId && (
            <Link href={getBlockExploreLink(address, 'address', chainId)}>
              (
              {t('View on %site%', {
                site: getBlockExploreName(chainId),
              })}
            </Link>
          )}
        </div>
        <input
          className="outline-0 py-2 w-full"
          type="text"
          autoComplete="off"
          autoCorrect="off"
          autoCapitalize="off"
          spellCheck="false"
          placeholder={t('Wallet Address')}
          pattern="^(0x[a-fA-F0-9]{40})$"
          onChange={handleInput}
          value={value}
        />
      </div>
    </div>
  )
}
